<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable
        apiEndpoint="/api/admin/herbs"
        title="药材管理"
        :columns="columns"
        :formFields="formFields"
      />
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '../components/AdminTable.vue'

export default {
  name: 'HerbsList',
  components: { Sidebar, AdminTable },
  data() {
    return {
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: '药材名' },
        { key: 'origin', label: '产地' },
        { key: 'created_at', label: '创建时间', type: 'date' }
      ],
      formFields: [
        { key: 'name', label: '药材名', type: 'text', required: true },
        { key: 'origin', label: '产地', type: 'text' }
      ]
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; padding: 30px; margin-left: 260px; }
</style>
